const buttonSearchMobile = document.querySelector('.js-button-search-mobile');
const closeSearchMobile = document.querySelector('.js-btn-search-close-mobile');


buttonSearchMobile.addEventListener('click', (e)=>{
    e.preventDefault();
    const nodoSearch = document.querySelector('.js-search-mobile-atoms');
    nodoSearch.classList.add('search-mobile-atoms-active');
})



closeSearchMobile.addEventListener('click', (e)=>{
    e.preventDefault();
    const nodoSearch = document.querySelector('.js-search-mobile-atoms');
    nodoSearch.classList.remove('search-mobile-atoms-active');
})